export default "__VITE_ASSET__3679f61a__"